import "prebid.js/modules/rubiconBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {RubiconAdUnit} from "header-bidding-base/modules/config/domain/bidders/rubiconConfig";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class RubiconBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<RubiconAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.RUBICON);
    }
}
